export const emailForConfirmProvideLaterStepSelector = () => {
  const {
    swag: {
      storeSettings
    }
  } = window;
  return (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.companyEmail) || 'support@swag.com';
};